import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { Link } from 'react-scroll';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { checkAllTrue } from 'common/utilities/utils';
import { PdpSummaryCardComponent } from 'atoms/PdpSummary/AU/Presentation/PdpSummaryCardComponent';

/**
 * PDP summary Component
 */
const PdpSummaryViewComponent = ({
  summaryData,
  pdpPromoPage,
  storeTimeZone,
  nutritionAllergenHandler,
  showNutritionAllergenModal,
  handleCloseModal,
  setNutritionAllergenModalOpen,
}) => {
  const { pdpCardObject, comboData, customizable, makeItComboHandler, showMakeItComboButton } = summaryData;

  const getMakeItComboView = () => {
    return (
      <Link activeClass='active' className='combo-btn' to={'pdp-combo'} offset={0} spy={true} smooth={true}>
        <ButtonComp
          tabIndex='1'
          className='button whiteButton blackBorder pdp-combo-button'
          data-testid='makeitcombo-btn'
          onClickHandler={makeItComboHandler}
        >
          <span>{translateWithI18Next('makeItACombo')}</span>
        </ButtonComp>
      </Link>
    );
  };

  const makeItComboView = checkAllTrue([!customizable, comboData > 0, showMakeItComboButton]) && getMakeItComboView();
  return (
    <div className='pdp-receipt-card'>
      <form
        className='pdp-receipt-form'
        onSubmit={event => {
          event?.preventDefault();
        }}
      >
        <h1 className='pdp-receipt-header'>{pdpCardObject?.dName}</h1>
        <PdpSummaryCardComponent
          {...summaryData}
          pdpPromoPage={pdpPromoPage}
          storeTimeZone={storeTimeZone}
          nutritionDetails={{
            nutritionAllergenHandler,
            showNutritionAllergenModal,
            handleCloseModal,
            setNutritionAllergenModalOpen,
          }}
        />
        {makeItComboView}
      </form>
    </div>
  );
};
export default React.memo(PdpSummaryViewComponent);
